import script from "./BalTextInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalTextInput.vue?vue&type=script&setup=true&lang=ts"

import "./BalTextInput.vue?vue&type=style&index=0&id=489ff850&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489ff850"]])

export default __exports__